<template>
  <svg class="product-list-view-icon" viewBox="0 0 64 40" width="64" height="40" aria-hidden="true" focusable="false">
    <rect class="plv-frame" x="0.5" y="0.5" width="63" height="39" rx="3" />
    <template v-if="view === 'default'">
      <g v-for="x in [5, 25, 45]" :key="x">
        <rect class="plv-muted" :x="x" y="6" width="14" height="14" rx="1" />
        <rect class="plv-fill" :x="x" y="23" width="12" height="3" rx="1" />
        <rect class="plv-muted" :x="x" y="28" width="9" height="2" rx="1" />
        <rect class="plv-accent" :x="x" y="32" width="8" height="3" rx="1" />
      </g>
    </template>
    <template v-else-if="view === 'list' || view === 'listpreview'">
      <g v-for="y in [6, 17, 28]" :key="y">
        <rect class="plv-muted" x="6" :y="y" width="7" height="7" rx="1" />
        <rect class="plv-fill" x="17" :y="y" width="26" height="3" rx="1" />
        <rect class="plv-muted" x="17" :y="y + 4.5" width="38" height="2" rx="1" />
      </g>
      <g v-if="view === 'listpreview'">
        <rect class="plv-window" x="38" y="14" width="22" height="22" rx="2" />
        <rect class="plv-muted" x="41" y="17" width="16" height="8" rx="1" />
        <rect class="plv-fill" x="41" y="27" width="12" height="2" rx="1" />
        <rect class="plv-muted" x="41" y="31" width="14" height="2" rx="1" />
      </g>
    </template>
    <template v-else-if="view === 'listdate' || view === 'listpreviewdate'">
      <path class="plv-arrow" d="M6 7 V31 M3 27.5 L6 31 L9 27.5" />
      <g v-for="y in [6, 17, 28]" :key="y">
        <rect class="plv-muted" x="13" :y="y" width="7" height="7" rx="1" />
        <rect class="plv-fill" x="23" :y="y" width="20" height="3" rx="1" />
        <rect class="plv-accent" x="48" :y="y" width="11" height="3" rx="1" />
        <rect class="plv-muted" x="23" :y="y + 4.5" width="30" height="2" rx="1" />
      </g>
      <g v-if="view === 'listpreviewdate'">
        <rect class="plv-window" x="40" y="18" width="21" height="19" rx="2" />
        <rect class="plv-muted" x="43" y="21" width="15" height="7" rx="1" />
        <rect class="plv-fill" x="43" y="30" width="11" height="2" rx="1" />
        <rect class="plv-muted" x="43" y="33.5" width="13" height="1.5" rx="0.75" />
      </g>
    </template>
    <template v-else-if="view === 'horizontalcard' || view === 'horizontalcardpreview'">
      <g v-for="y in [4, 22]" :key="y">
        <rect class="plv-muted" x="4" :y="y" width="14" height="14" rx="1" />
        <rect class="plv-fill" x="21" :y="y + 1" width="22" height="2.5" rx="1" />
        <rect class="plv-muted" x="21" :y="y + 5.5" width="34" height="2" rx="1" />
        <rect class="plv-accent" x="21" :y="y + 9.5" width="12" height="3.5" rx="1" />
      </g>
      <g v-if="view === 'horizontalcardpreview'">
        <rect class="plv-window" x="38" y="14" width="22" height="22" rx="2" />
        <rect class="plv-muted" x="41" y="17" width="16" height="8" rx="1" />
        <rect class="plv-fill" x="41" y="27" width="12" height="2" rx="1" />
        <rect class="plv-muted" x="41" y="31" width="14" height="2" rx="1" />
      </g>
    </template>
    <template v-else-if="view === 'horizontalcardpreviewdate'">
      <path class="plv-arrow" d="M6 7 V31 M3 27.5 L6 31 L9 27.5" />
      <g v-for="y in [4, 22]" :key="y">
        <rect class="plv-muted" x="12" :y="y" width="14" height="14" rx="1" />
        <rect class="plv-fill" x="29" :y="y + 1" width="18" height="2.5" rx="1" />
        <rect class="plv-muted" x="29" :y="y + 5.5" width="26" height="2" rx="1" />
        <rect class="plv-accent" x="29" :y="y + 9.5" width="11" height="3.5" rx="1" />
      </g>
      <rect class="plv-window" x="40" y="18" width="21" height="19" rx="2" />
      <rect class="plv-muted" x="43" y="21" width="15" height="7" rx="1" />
      <rect class="plv-fill" x="43" y="30" width="11" height="2" rx="1" />
      <rect class="plv-muted" x="43" y="33.5" width="13" height="1.5" rx="0.75" />
    </template>
    <template v-else-if="view === 'imagerows'">
      <g v-for="y in [5, 22]" :key="y">
        <rect class="plv-muted" x="5" :y="y" width="24" height="13" rx="1" />
        <rect class="plv-fill" x="33" :y="y + 1" width="20" height="3" rx="1" />
        <rect class="plv-muted" x="33" :y="y + 6" width="26" height="2" rx="1" />
        <rect class="plv-muted" x="33" :y="y + 10" width="22" height="2" rx="1" />
      </g>
    </template>
    <template v-else-if="view === 'showtimes'">
      <g v-for="y in [5, 22]" :key="y">
        <rect class="plv-muted" x="5" :y="y" width="10" height="13" rx="1" />
        <rect class="plv-fill" x="19" :y="y + 1" width="22" height="3" rx="1" />
        <rect class="plv-accent" x="19" :y="y + 7" width="9" height="4" rx="1" />
        <rect class="plv-accent" x="31" :y="y + 7" width="9" height="4" rx="1" />
        <rect class="plv-accent" x="43" :y="y + 7" width="9" height="4" rx="1" />
      </g>
    </template>
    <template v-else-if="view === 'availabilitylist' || view === 'fulltextsearch' || view === 'availabilityfulltext'">
      <rect class="plv-window" x="5" y="5" width="54" height="9" rx="2" />
      <g v-if="view !== 'availabilitylist'">
        <circle class="plv-line" cx="11" cy="9.5" r="2.3" />
        <path class="plv-line" d="M12.7 11.2 L14.5 13" />
      </g>
      <rect v-if="view !== 'fulltextsearch'" class="plv-accent" :x="view === 'availabilityfulltext' ? 40 : 8" y="7.5" width="16" height="4" rx="1" />
      <rect v-if="view === 'fulltextsearch'" class="plv-muted" x="17" y="8.5" width="20" height="2" rx="1" />
      <g v-for="x in [5, 25, 45]" :key="x">
        <rect class="plv-muted" :x="x" y="18" width="14" height="10" rx="1" />
        <rect class="plv-fill" :x="x" y="30" width="12" height="2.5" rx="1" />
        <rect class="plv-muted" :x="x" y="34" width="9" height="2" rx="1" />
      </g>
    </template>
    <template v-else>
      <rect class="plv-dashed" x="6" y="6" width="52" height="28" rx="2" />
      <rect class="plv-muted" x="14" y="15" width="36" height="3" rx="1" />
      <rect class="plv-muted" x="20" y="22" width="24" height="3" rx="1" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'ProductListViewIcon',
  props: {
    view: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.product-list-view-icon {
  display: block;
  flex: 0 0 auto;
  color: #555;
}
.plv-frame {
  fill: #fff;
  stroke: currentColor;
  stroke-opacity: 0.25;
}
.plv-fill {
  fill: currentColor;
  fill-opacity: 0.8;
}
.plv-muted {
  fill: currentColor;
  fill-opacity: 0.25;
}
.plv-accent {
  fill: #2a9fd6;
}
.plv-window {
  fill: #fff;
  stroke: currentColor;
  stroke-opacity: 0.6;
}
.plv-line,
.plv-arrow {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.plv-arrow {
  stroke: #2a9fd6;
}
.plv-dashed {
  fill: none;
  stroke: currentColor;
  stroke-opacity: 0.4;
  stroke-dasharray: 3 2;
}
</style>
